import { DrugGetResponse, DrugListRequest, DrugListResult, DrugPricingRequest, DrugPricingResponse } from "../types";
import { request } from "./request";

export async function getDrug(drugGetRequest: {drug_id: number}): Promise<DrugGetResponse> {
  return await request({
    url: "/drug/get",
    method: "POST",
    data: { ...drugGetRequest },
  });
}

export async function drugNamesList(drugNameRequest: DrugListRequest): Promise<DrugListResult> {
  return await request({
    url: "/drug/list",
    method: "POST",
    data: { ...drugNameRequest },
  });
}

export async function priceDrugAPI(drugPriceRequest: DrugPricingRequest): Promise<DrugPricingResponse> {
  return await request({
    url: "/drug/price/list",
    method: "POST",
    data: { ...drugPriceRequest },
  });
}
